import React, { useEffect, useRef, useState, useCallback } from 'react'
import st from './Deals.module.scss'
import MultiActionMenu from 'components/CRM/UI/components/MultiActionMenu/MultiActionMenu'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import asideModalStore from 'Stores/asideModalStore'
import DealsCardAppearance from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/DealsCardAppearance/DealsCardAppearance'
import useWindowWidth from 'components/CRM/utils/hooks/useWindowWidth'
import { superAxiosRequest } from 'axiosApi'
import AddNewDeal from 'components/ContentBox/Global/GlobalModalSingle/templates/CRM/AddNewDeal/AddNewDeal'
import Button from 'components/CRM/UI/components/Button/Button'
import { observer } from 'mobx-react'
import { useHistory, useLocation } from 'react-router-dom'
import Loader from 'components/UI/Loader/Loader'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import ColumnDeals from './ColumnDeals/ColumnDeals'
import ReasonRejectModal from './DealsCard/ReasonRejectModal/ReasonRejectModal'
import RequiredFieldsPaidModal from './DealsCard/RequiredFieldsConsultedModal/RequiredFieldsPaidModal'
import RequiredFieldsConsultedModal from './DealsCard/RequiredFieldsPaidModal/RequiredFieldsConsultedModal'
import MergeDealsForm from './MergeDealsForm/MergeDealsForm'
import MassEditDealsForm from './MassEditDealsForm/MassEditDealsForm'
import swal from 'sweetalert'
import RequiredFieldsModal from './DealsCard/RequiredFieldsModal/RequiredFieldsModal'
import RequiredFieldsModalMeetings from './DealsCard/RequiredFieldsModalMeetings/RequiredFieldsModalMeetings'
import { checkPermList } from '../../../helpers'
import { permissions } from '../../../settings/permissions'
import MassAddTasksForm from './MassAddTasks/MassAddTasksForm'

const Deals = () => {
  const windowWidth = useWindowWidth()
  const [sources, setSources] = useState([])
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const funnelId = searchParams.get('funnel_id')

  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      set_up_funnel: 'Set up a funnel',
      new_deals: 'New Deals',
      search_placeholder: 'Search',
      deals: 'Deals',
      import: 'Import',
      export: 'Export',
      card_appearance: 'Card appearance',
      search_duplicates: 'Search for duplicates',
      mass_actions: 'Mass actions',
      sorting: 'Sorting',
      by_creation_date: 'By creation date',
      by_name: 'By name',
      by_budget: 'By budget',
      auto_update: 'Auto update',
      by_status: 'By status',
      all_branches: 'All branches',
      city: 'City',
      quick_add: 'QUICK ADD',
      deal_name: 'Deal name',
      responsible: 'Responsible',
      enable_feature_x: 'Enable Feature X',
      new_deal: 'New deal',
      creating_new_deal: 'Creating a new deal',
      add_new_task: 'Add a new task',
      no_name: 'No name',
      reason_reject: 'Причина отказа',
    },
  })

  const [reasons, setReasons] = useState(null)
  const [sourceData, setSourceData] = useState(null)

  const fetchSource = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_source_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setSourceData(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки:', error)
    }
  }
  const fetchReasons = async () => {
    try {
      const { data } = await superAxiosRequest({
        link: `settings/project_settings/deal_reject_reason_choices`,
        method: 'get',
        crm: true,
      })
      if (data?.value?.choices) {
        setReasons(data.value.choices)
      }
    } catch (error) {
      console.error('Ошибка загрузки причин:', error)
    }
  }

  useEffect(() => {
    fetchReasons()
    fetchSource()
  }, [])

  const filterCfg = [
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: 'Период',
    },
    {
      type: 'select-multi-obj',
      apiLinkCRM: 'integration/deal_statuses',
      nameState: 'status_deal',
      apiConfParams: { funnel_id: funnelId },
      label: translate?.by_status,
      placeholder: translate?.by_status,
      apiGetResult: (data) => {
        if (Array.isArray(data)) return data
        const source = data?.statuses ?? data
        return Object.values(source ?? {}).sort(
          (a, b) => a.position - b.position,
        )
      },
      optionLabelKey: 'name',
      optionValueKey: 'id',
    },
    {
      label: translate?.deal_name,
      nameState: 'deal_name',
      type: 'input',
      placeholder: translate?.deal_name,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/employees/?short_form=true',
      nameState: 'manager',
      label: translate?.responsible,
      placeholder: translate?.responsible,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/cities',
      apiConfParams: { limit: 99 },
      nameState: 'city',
      label: translate?.city,
      placeholder: translate?.city,
    },
    {
      type: 'select-multi',
      apiLinkCRM: 'integration/branches',
      nameState: 'branch',
      label: translate?.all_branches,
      placeholder: translate?.all_branches,
    },
    {
      type: 'select-multi',
      label: 'Источник',
      placeholder: 'Источник',
      values: sources.map((el) => ({
        id: el.id,
        name: `${el.name} ${el.comment ?? ''}`,
      })),
      sort_key: 'name',
      nameState: 'source_id',
    },
    {
      type: 'select-multi',
      label: 'Откуда пришли',
      placeholder: 'Откуда пришли',
      values: sourceData?.map((el) => ({
        id: el.name,
        name: el.name,
      })),
      sort_key: 'name',
      nameState: 'source',
    },
    {
      type: 'select-multi',
      label: translate?.reject_reason || 'Причина отказа',
      placeholder: translate?.reject_reason || 'Причина отказа',
      values: reasons?.map((el) => ({
        id: el.name,
        name: el.name,
      })),
      sort_key: 'name',
      nameState: 'reject_reason',
    },
    {
      type: 'exclusive_checkbox',
      nameState: 'task_filter',
      label: 'Задачи',
      options: [
        { name: 'overdue_tasks', label: 'Просроченные задачи' },
        { name: 'without_tasks', label: 'Сделки без задач' },
      ],
    },
    {
      type: 'input_number',
      nameState: 'age',
      label: 'Возраст',
      placeholder: 'Возраст',
      maxLength: 3,
    },
    {
      type: 'input_number',
      nameState: 'admission_year',
      label: 'Год поступления',
      placeholder: 'Год поступления',
      maxLength: 4,
    },
  ]

  // -----------------------------------------------------------------------------------------------------------------------------------------------
  const [selectedDeals, setSelectedDeals] = useState([])
  const [isMergeModalOpen, setIsMergeModalOpen] = useState(false)
  const [isMassEditModalOpen, setIsMassEditModalOpen] = useState(false)
  const [isMassAddTasksModalOpen, setIsMassAddTasksModalOpen] = useState(false)
  const [dealsForAction, setDealsForAction] = useState([])
  const [isLoadingActionData, setIsLoadingActionData] = useState(false)

  const closeMassAddTasksModal = () => {
    setIsMassAddTasksModalOpen(false)
    setDealsForAction([])
  }

  const handleMassAddTasks = async (payload) => {
    try {
      await superAxiosRequest(
        {
          link: 'tasktracker/tasks',
          method: 'post',
          crm: true,
        },
        payload,
      )

      closeMassAddTasksModal()
      clearSelection()
      swal('Успех!', `Задачи созданы для ${payload.length} сделок`, 'success')
    } catch (error) {
      console.error('Ошибка при создании задач:', error)
      swal('Ошибка!', 'Не удалось создать задачи', 'error')
    }
  }

  const MassAddTasksButton = () => {
    if (selectedDeals.length < 1) return null

    return (
      <Button
        text={`Добавить задачи (${selectedDeals.length})`}
        onClick={() => fetchDealsForAction('massAddTasks')}
        withIcon
      />
    )
  }

  const toggleDealSelection = (dealId) => {
    setSelectedDeals((prev) => {
      if (prev.includes(dealId)) {
        return prev.filter((id) => id !== dealId)
      } else {
        return [...prev, dealId]
      }
    })
  }

  const fetchDealsForAction = async (actionType) => {
    if (selectedDeals.length < 2 && actionType !== 'massAddTasks') return
    if (selectedDeals.length < 1 && actionType === 'massAddTasks') return

    setIsLoadingActionData(true)
    try {
      const promises = selectedDeals.map((dealId) =>
        superAxiosRequest({
          link: `integration/deals/${dealId}`,
          method: 'get',
          crm: true,
        }),
      )

      const responses = await Promise.all(promises)
      const dealsData = responses.map((response) => response.data)
      setDealsForAction(dealsData)

      if (actionType === 'merge') {
        setIsMergeModalOpen(true)
      } else if (actionType === 'massEdit') {
        setIsMassEditModalOpen(true)
      } else if (actionType === 'massAddTasks') {
        setIsMassAddTasksModalOpen(true)
      }
    } catch (error) {
      console.error('Error fetching deals:', error)
      swal('Ошибка!', 'Не удалось загрузить данные сделок', 'error')
    } finally {
      setIsLoadingActionData(false)
    }
  }

  const closeMergeModal = () => {
    setIsMergeModalOpen(false)
    setDealsForAction([])
  }

  const closeMassEditModal = () => {
    setIsMassEditModalOpen(false)
    setDealsForAction([])
  }

  const clearSelection = () => {
    setSelectedDeals([])
  }

  const handleMerge = async (payload) => {
    try {
      await superAxiosRequest(
        {
          link: 'integration/deals_combine',
          method: 'post',
          crm: true,
        },
        payload,
      )

      closeMergeModal()
      clearSelection()
      clearData()
      swal('Успех!', 'Сделки успешно объединены!', 'success')
    } catch (error) {
      console.error('Ошибка при объединении сделок:', error)
      swal('Ошибка!', 'Не удалось объединить сделки', 'error')
    }
  }

  const handleMassEdit = async (payload) => {
    try {
      await superAxiosRequest(
        {
          link: 'integration/bulk_update_deals',
          method: 'post',
          crm: true,
        },
        payload,
      )

      closeMassEditModal()
      clearSelection()
      clearData()
      refreshAllColumns()
      swal(
        'Успех!',
        `Изменения применены к ${payload.deal_ids.length} сделкам`,
        'success',
      )
    } catch (error) {
      console.error('Ошибка при массовом обновлении:', error)
      swal('Ошибка!', 'Не удалось применить изменения', 'error')
    }
  }

  const refreshAllColumns = () => {
    visibleColumns.forEach((column) => {
      refreshColumnCompletely(column.id)
    })
  }

  const MergeButton = () => {
    if (selectedDeals.length < 2 || selectedDeals.length > 5) return null

    return (
      <Button
        text={`Объединить сделки (${selectedDeals.length})`}
        onClick={() => fetchDealsForAction('merge')}
        withIcon
      />
    )
  }

  const MassEditButton = () => {
    if (selectedDeals.length < 2) return null

    return (
      <Button
        text={`Массовые изменения (${selectedDeals.length})`}
        onClick={() => fetchDealsForAction('massEdit')}
        withIcon
      />
    )
  }

  const ClearSelectionButton = () => {
    if (selectedDeals.length === 0) return null

    return (
      <Button
        text={`Очистить выбор (${selectedDeals.length})`}
        onClick={clearSelection}
        whiteBtn
      />
    )
  }

  // -----------------------------------------------------------------------------------------------------------------------------------------------

  const [filter, updateFilter] = useLocalStorageFilter()
  const history = useHistory()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [dealsMap, setDealsMap] = useState({})
  const [totalMap, setTotalMap] = useState({})
  const [page, setPage] = useState({})
  const [columns, setColumns] = useState([])
  const [loading, setLoading] = useState(false)
  const [autoupdate, setAutoupdate] = useState(false)

  const [funnels, setFunnels] = useState([])

  const [checked, setChecked] = useState(() => {
    return JSON.parse(localStorage.getItem('auto_update_crm')) || false
  })
  const [sortOrder, setSortOrder] = useState('created_at')

  const [pendingDragData, setPendingDragData] = useState(null)

  const getSelectedStatusIds = React.useMemo(() => {
    if (!filter?.status_deal) return []
    if (Array.isArray(filter.status_deal)) {
      return filter.status_deal
        .map((s) => (typeof s === 'object' && s !== null ? s.id : s))
        .filter((id) => id !== undefined && id !== null)
    }
    const singleId =
      typeof filter.status_deal === 'object' && filter.status_deal !== null
        ? filter.status_deal.id
        : filter.status_deal
    return singleId !== undefined && singleId !== null ? [singleId] : []
  }, [filter?.status_deal])

  const visibleColumns = React.useMemo(() => {
    if (getSelectedStatusIds.length === 0) return columns
    return columns.filter((col) => getSelectedStatusIds.includes(col.id))
  }, [columns, getSelectedStatusIds])

  const filterForColumns = React.useMemo(() => {
    if (!filter) return {}

    const { status_deal, task_filter, age, admission_year, ...rest } = filter

    const result = { ...rest }

    if (task_filter === 'overdue_tasks') {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      result.finish_task = `${year}-${month}-${day}`
    }

    if (task_filter === 'without_tasks') {
      result.without_tasks = true
    }

    if (age != null && Number(age) > 0) {
      const today = new Date()
      const birthDate = new Date(
        today.getFullYear() - Number(age),
        today.getMonth(),
        today.getDate(),
      )

      const formatDate = (d) => {
        const y = d.getFullYear()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${y}-${m}-${day}`
      }

      result.birth_date_from = `${birthDate.getFullYear()}-01-01`
      result.birth_date_until = formatDate(birthDate)
    }

    if (admission_year != null && Number(admission_year) > 0) {
      result.planned_admission_year = Number(admission_year)
    }

    return result
  }, [filter])

  const columnConfig = {
    69: {
      type: 'meeting_scheduled',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
        'meeting_format',
        'consultation_date',
      ],
      modalComponent: RequiredFieldsModalMeetings,
    },
    70: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    71: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    95: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    290: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        // 'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    291: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    292: {
      type: 'standard',
      requiredFields: [
        'city',
        'year_of_study',
        'level_result',
        'country_of_admission',
        'planned_specialty',
        'budget',
        'program',
      ],
      modalComponent: RequiredFieldsModal,
    },
    334: {
      type: 'standard',
      requiredFields: ['reject_reason'],
      modalComponent: ReasonRejectModal,
    },
  }

  const isSpecialColumn = (columnId) => {
    return columnConfig[columnId] !== undefined
  }

  const getRequiredFieldsForColumn = (columnId) => {
    return columnConfig[columnId]?.requiredFields || []
  }

  const hasRequiredFields = (deal, targetColumnId) => {
    const requiredFields = getRequiredFieldsForColumn(targetColumnId)

    if (requiredFields.length === 0) return true

    return requiredFields.every((field) => {
      const value = deal[field]
      return value !== undefined && value !== null && value !== ''
    })
  }

  const openRequiredFieldsModal = (deal, targetColumnId) => {
    const config = columnConfig[targetColumnId]
    if (!config) return

    const ModalComponent = config.modalComponent
    const requiredFields = config.requiredFields

    const valid = {}
    requiredFields.forEach((field) => {
      valid[field] = 'required'
    })

    const md = {
      deal_name: deal.deal_name,
      manager: deal.manager?.id,
      client: deal.client?.id,
      budget: deal.budget,
      city: deal.city?.id,
      branch: deal.branch?.id,
      program: deal.program?.id,
      source: deal.source,
      funnels: [funnelId],

      year_of_study: deal.year_of_study,
      level_result: deal.level_result,
      country: deal.country,
      country_of_admission: deal.country_of_admission,
      planned_specialty: deal.planned_specialty,

      meeting_format: deal.meeting_format,
      consultation_date: deal.consultation_date,

      reject_reason: deal.reject_reason,
    }

    const ms = {
      modalBodyComponent: () => <ModalComponent />,
      button: 'Save',
      link: `integration/deals/${deal.id}`,
      title: getModalTitle(targetColumnId),
      is_put: true,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: (responseData) =>
        moveDealAfterValidation(deal.id, targetColumnId, responseData),
      valid,
    }

    asideModalStore.activity(ms, md)
  }

  const getModalTitle = (columnId) => {
    const titles = {
      334: 'Добавить причину отказа',
      65: 'Заполните обязательные поля',
      13: 'Заполните информацию об обучении',
      69: 'Заполните данные для встречи',
      70: 'Заполните обязательные поля',
      71: 'Заполните обязательные поля',
      95: 'Заполните обязательные поля',
      290: 'Заполните обязательные поля',
      291: 'Заполните обязательные поля',
      292: 'Заполните обязательные поля',
    }
    return titles[columnId] || 'Заполните обязательные поля'
  }

  const clearData = () => {
    setDealsMap({})
    setPage({})
  }

  const moveDealAfterValidation = (dealId, targetColumnId, updatedDeal) => {
    const sourceColumnId = Object.keys(dealsMap).find((colId) =>
      dealsMap[colId]?.some((deal) => deal.id === dealId),
    )

    if (!sourceColumnId) return

    const deal = dealsMap[sourceColumnId].find((d) => d.id === dealId)
    if (!deal) return

    const mergedDeal = { ...deal, ...updatedDeal }

    let targetIndex = 0
    if (pendingDragData && pendingDragData.targetColumnId === targetColumnId) {
      targetIndex = pendingDragData.targetIndex
    }

    setDealsMap((prev) => ({
      ...prev,
      [sourceColumnId]: prev[sourceColumnId].filter((el) => el.id !== dealId),
      [targetColumnId]: addElementAtIndex(
        prev[targetColumnId] || [],
        targetIndex,
        mergedDeal,
      ),
    }))

    setTotalMap((prev) => ({
      ...prev,
      [sourceColumnId]: {
        ...prev[sourceColumnId],
        total: (prev[sourceColumnId]?.total || 0) - 1,
        budgetSum: (prev[sourceColumnId]?.budgetSum || 0) - (deal.budget || 0),
      },
      [targetColumnId]: {
        ...prev[targetColumnId],
        total: (prev[targetColumnId]?.total || 0) + 1,
        budgetSum:
          (prev[targetColumnId]?.budgetSum || 0) + (mergedDeal.budget || 0),
      },
    }))

    superAxiosRequest(
      {
        link: `integration/deals/${dealId}/change_status_deal`,
        method: 'post',
        crm: true,
      },
      {
        new_deal_status_id: targetColumnId,
        funnel_id: funnelId,
      },
    )
      .then(() => {
        refreshColumnCompletely(targetColumnId)
        setPendingDragData(null)
      })
      .catch((error) => {
        console.error('Error changing deal status:', error)
      })
  }

  const handleDragEnd = async (result) => {
    const { source, destination } = result

    if (!destination) return

    const start = +source.droppableId
    const finish = +destination.droppableId

    if (source.droppableId === destination.droppableId) return

    const isTargetSpecialColumn = isSpecialColumn(finish)
    const selectedDeal = dealsMap[start]?.[source.index]
    if (!selectedDeal) return

    let fullDeal = selectedDeal
    if (isTargetSpecialColumn) {
      try {
        const { data } = await superAxiosRequest({
          link: `integration/deals/${selectedDeal.id}`,
          method: 'get',
          crm: true,
        })
        fullDeal = data?.result ?? data ?? selectedDeal
      } catch (e) {
        console.error('Не удалось загрузить сделку:', e)
      }
    }

    if (isTargetSpecialColumn && !hasRequiredFields(fullDeal, finish)) {
      setPendingDragData({
        deal: fullDeal,
        sourceColumnId: start,
        sourceIndex: source.index,
        targetColumnId: finish,
        targetIndex: destination.index,
      })

      openRequiredFieldsModal(fullDeal, finish)
      return
    }

    moveDealImmediately(
      start,
      finish,
      selectedDeal,
      source.index,
      destination.index,
    )
  }

  const moveDealImmediately = (
    start,
    finish,
    selectedDeal,
    sourceIndex,
    destinationIndex,
  ) => {
    setDealsMap((prev) => ({
      ...prev,
      [start]: prev[start]?.filter((el, index) => index !== sourceIndex) || [],
      [finish]: addElementAtIndex(
        prev[finish] || [],
        destinationIndex,
        selectedDeal,
      ),
    }))

    setTotalMap((prev) => ({
      ...prev,
      [start]: {
        ...prev[start],
        total: (prev[start]?.total || 0) - 1,
        budgetSum: (prev[start]?.budgetSum || 0) - (selectedDeal.budget || 0),
      },
      [finish]: {
        ...prev[finish],
        total: (prev[finish]?.total || 0) + 1,
        budgetSum: (prev[finish]?.budgetSum || 0) + (selectedDeal.budget || 0),
      },
    }))

    superAxiosRequest(
      {
        link: `integration/deals/${selectedDeal.id}/change_status_deal`,
        method: 'post',
        crm: true,
      },
      {
        new_deal_status_id: finish,
        funnel_id: funnelId,
      },
    )
      .then(() => {
        refreshColumnCompletely(finish)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const refreshColumnCompletely = (columnId) => {
    setPage((prev) => ({
      ...prev,
      [columnId]: 0,
    }))

    const queryParams = {
      ...filterForColumns,
      funnel_id: funnelId,
      order_by: sortOrder,
      offset: 0,
      status_deal: columnId,
    }

    superAxiosRequest({
      link: 'integration/deals',
      method: 'get',
      crm: true,
      params: queryParams,
    })
      .then((response) => {
        setDealsMap((prev) => ({
          ...prev,
          [columnId]: response.data.result || [],
        }))

        setTotalMap((prev) => ({
          ...prev,
          [columnId]: {
            total: response.data._meta?.count_items || 0,
            budgetSum: response.data._meta?.total_price?.budget__sum || 0,
          },
        }))
      })
      .catch(() => {})
  }

  useEffect(() => {
    if (pendingDragData) {
      setPendingDragData(null)
    }
  }, [pendingDragData])

  const resetFilter = (key) => {
    if (!filter) return

    const { [key]: _, ...rest } = filter
    updateFilter(rest)
    changeTextValue(key, null)
    setTextValues(filterTextValues.filter((field) => field.key !== key))
  }

  const handleStatusDealFilter = (statusId) => {
    const selectedStatus = columns.find((column) => column.id === statusId)

    if (selectedStatus) {
      if (
        getSelectedStatusIds.length === 1 &&
        getSelectedStatusIds[0] === statusId
      ) {
        resetFilter('status_deal')
      } else {
        updateFilter({ ...filter, status_deal: statusId })
        changeTextValue('status_deal', {
          key: 'status_deal',
          label: translate?.by_status || 'By status',
          value: selectedStatus.name,
        })
      }
    }
  }

  useEffect(() => {
    setLoading(true)
    clearData()
    superAxiosRequest({
      link: 'integration/deal_statuses',
      method: 'get',
      crm: true,
      params: {
        funnel_id: funnelId,
      },
    })
      .then((response) => {
        const statusesArray = Object.values(response.data).sort(
          (a, b) => a.position - b.position,
        )
        setColumns(statusesArray)
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false)
      })
  }, [filter])

  useEffect(() => {
    superAxiosRequest({
      link: 'integration/funnels',
      method: 'get',
      crm: true,
      params: {
        my_onlyfunns: true,
      },
    })
      .then((res) => {
        setFunnels(res.data)
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    superAxiosRequest({
      link: 'integration/sources',
      method: 'get',
      crm: true,
    })
      .then((res) => {
        setSources(res.data)
      })
      .catch(() => {})
  }, [])

  useEffect(() => {
    localStorage.setItem('auto_update_crm', JSON.stringify(checked))
    if (checked) {
      const intervalId = setInterval(() => {
        clearData()
        setAutoupdate((prev) => !prev)
      }, 400000)
      return () => clearInterval(intervalId)
    }
  }, [checked, sortOrder])

  const handleCheckboxChange = () => {
    setChecked(!checked)
  }

  const menu = React.useMemo(() => {
    const baseMenu = [
      { name: translate.import, action: 'import' },
      { name: translate.export, action: 'export' },
      { name: translate.card_appearance, action: 'card_appearance' },
      { name: translate.search_duplicates, action: 'search_for_duplicates' },
      { name: translate.mass_actions, action: 'mass_actions' },
      { line: true },
      { title: translate.sorting },
      { name: translate.by_creation_date, action: 'byDate' },
      { name: translate.by_name, action: 'byName' },
      { name: translate.by_budget, action: 'byBudget' },
      { line: true },
      {
        name: translate.enable_feature_x,
        action: 'enable_feature_x',
        checkbox: {
          label: translate.auto_update,
          value: checked,
          onChange: handleCheckboxChange,
        },
      },
    ]

    if (selectedDeals.length > 0) {
      baseMenu.splice(4, 0, {
        name: `Добавить задачи (${selectedDeals.length})`,
        action: 'mass_add_tasks',
      })
    }

    return baseMenu
  }, [checked, selectedDeals.length, handleCheckboxChange])

  const menuMobile = [
    { name: translate.new_deal, action: 'new_deal' },
    { name: translate.set_up_funnel, action: 'set_up_funnel' },
    { line: true },
    ...menu,
  ]

  const addNewDealModal = () => {
    const ms = {
      modalBodyComponent: () => <AddNewDeal />,
      button: translate?.save,
      link: 'integration/deals',
      title: translate?.creating_new_deal,
      isResponsive: true,
      crm: true,
      onSubmitSuccess: (data) => {
        setDealsMap((prev) => ({
          ...prev,
          [columns[0].id]: [
            {
              budget: data.budget,
              city: data.city,
              client: data.client,
              client_text_name: data.client_text_name,
              created_at: data.created_at,
              deal_name: data.deal_name,
              funnels: data.funnels,
              id: data.id,
              manager: data.manager,
              program: data.program,
            },
            ...(prev[columns[0].id] || []),
          ],
        }))
      },
      valid: {},
    }
    const md = {
      program: null,
      manager: null,
      branch: null,
      funnels: [funnelId],
    }
    asideModalStore.activity(ms, md)
  }

  const funnelPage = () => {
    return history.push(`/crm/funnels/?funnel_id=${funnelId}`)
  }

  const updateSortOrder = (orderBy) => {
    setSortOrder(orderBy)
    clearData()
  }

  const action = (action) => {
    switch (action) {
      case 'new_deal':
        addNewDealModal()
        break
      case 'mass_add_tasks':
        fetchDealsForAction('massAddTasks')
        break
      case 'set_up_funnel':
        funnelPage()
        break
      case 'import':
        break
      case 'export':
        break
      case 'card_appearance':
        break
      case 'search_for_duplicates':
        history.push('/crm/double')
        break
      case 'mass_actions':
        break
      case 'byDate':
        updateSortOrder('created_at')
        break
      case 'byName':
        updateSortOrder('deal_name')
        break
      case 'byBudget':
        updateSortOrder('budget')
        break
      case 'enable_feature_x':
        break
      default:
        break
    }
  }

  const addElementAtIndex = (array, index, element) => {
    return [
      ...(array?.slice(0, index) || []),
      element,
      ...(array?.slice(index) || []),
    ]
  }

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== `/crm/deals/?funnel_id=${funnelId}`) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const menuItems = funnels.map((funnel) => ({
    name: funnel.name,
    action: `navigate_to_funnel_${funnel.id}`,
  }))

  const createActionFunction = (funnelId) => {
    return () => {
      window.location.href = `/crm/deals/?funnel_id=${funnelId}`
    }
  }

  const actionFunctions = {}
  funnels.forEach((funnel) => {
    actionFunctions[`navigate_to_funnel_${funnel.id}`] = createActionFunction(
      funnel.id,
    )
  })

  const handleSelectAllInColumn = (columnId, dealsInColumn) => {
    if (!dealsInColumn || dealsInColumn.length === 0) return

    const allSelected = dealsInColumn.every((deal) =>
      selectedDeals.includes(deal.id),
    )

    if (allSelected) {
      setSelectedDeals((prev) =>
        prev.filter((id) => !dealsInColumn.some((deal) => deal.id === id)),
      )
    } else {
      const newSelectedIds = dealsInColumn
        .filter((deal) => !selectedDeals.includes(deal.id))
        .map((deal) => deal.id)

      setSelectedDeals((prev) => [...prev, ...newSelectedIds])
    }
  }

  const totalDealsCount = React.useMemo(() => {
    if (getSelectedStatusIds.length > 0) {
      return getSelectedStatusIds.reduce((sum, id) => {
        return sum + (totalMap[id]?.total || 0)
      }, 0)
    }
    return Object.values(totalMap).reduce((sum, column) => {
      return sum + (column?.total || 0)
    }, 0)
  }, [totalMap, getSelectedStatusIds])

  // ============================================================
  // ЛОГИКА ДИСКРЕТНОГО СКРОЛЛБАРА
  // ============================================================
  const scrollContainerRef = useRef(null)
  const scrollbarRef = useRef(null)

  const [visibleRange, setVisibleRange] = useState([0, 0])
  const [isDragging, setIsDragging] = useState(false)
  const [hasScroll, setHasScroll] = useState(false)

  const dragStartXRef = useRef(0)
  const dragStartScrollRef = useRef(0)

  const totalColumns = visibleColumns.length

  // --- Получить все DOM-элементы колонок ---
  const getColumnElements = useCallback(() => {
    const container = scrollContainerRef.current
    if (!container) return []
    return Array.from(container.querySelectorAll('[data-column-index]'))
  }, [])

  // --- Определяем, какие колонки сейчас видны ---
  const updateVisibleRange = useCallback(() => {
    const container = scrollContainerRef.current
    if (!container || totalColumns === 0) return

    const { scrollWidth, clientWidth } = container

    if (scrollWidth <= clientWidth + 1) {
      setVisibleRange([0, totalColumns - 1])
      return
    }

    const columnElements = getColumnElements()
    if (columnElements.length === 0) return

    const containerRect = container.getBoundingClientRect()
    let firstVisible = -1
    let lastVisible = -1

    columnElements.forEach((el, idx) => {
      const rect = el.getBoundingClientRect()
      const isVisible =
        rect.right > containerRect.left + 1 &&
        rect.left < containerRect.right - 1

      if (isVisible) {
        if (firstVisible === -1) firstVisible = idx
        lastVisible = idx
      }
    })

    if (firstVisible === -1) {
      firstVisible = 0
      lastVisible = 0
    }

    setVisibleRange((prev) => {
      if (prev[0] === firstVisible && prev[1] === lastVisible) return prev
      return [firstVisible, lastVisible]
    })
  }, [totalColumns, getColumnElements])

  // --- Подписка на скролл и resize ---
  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) return

    updateVisibleRange()

    const resizeObserver = new ResizeObserver(() => {
      updateVisibleRange()
      setHasScroll(container.scrollWidth > container.clientWidth + 1)
    })
    resizeObserver.observe(container)

    container.addEventListener('scroll', updateVisibleRange)

    return () => {
      resizeObserver.disconnect()
      container.removeEventListener('scroll', updateVisibleRange)
    }
  }, [dealsMap, visibleColumns, updateVisibleRange])

  // --- Проверка наличия скролла ---
  useEffect(() => {
    const container = scrollContainerRef.current
    if (!container) return

    const check = () => {
      setHasScroll(container.scrollWidth > container.clientWidth + 1)
    }

    check()
    const ro = new ResizeObserver(check)
    ro.observe(container)

    return () => ro.disconnect()
  }, [dealsMap, visibleColumns])

  // --- Начало перетаскивания ---
  const handleScrollbarMouseDown = (e) => {
    if (e.button !== 0) return
    e.preventDefault()
    e.stopPropagation()

    setIsDragging(true)
    dragStartXRef.current = e.clientX
    dragStartScrollRef.current = scrollContainerRef.current?.scrollLeft || 0
  }

  // --- Глобальные слушатели для drag ---
  useEffect(() => {
    if (!isDragging) return

    const handleMouseMove = (e) => {
      const container = scrollContainerRef.current
      const scrollbar = scrollbarRef.current
      if (!container || !scrollbar) return

      const { scrollWidth, clientWidth } = container
      const maxScroll = scrollWidth - clientWidth
      if (maxScroll <= 0) return

      const deltaX = e.clientX - dragStartXRef.current

      // 1 сегмент скроллбара = 1 колонка контента
      const segmentWidth = scrollbar.offsetWidth / totalColumns
      const scrollDelta = (deltaX / segmentWidth) * (maxScroll / totalColumns)

      const newScrollLeft = Math.max(
        0,
        Math.min(maxScroll, dragStartScrollRef.current + scrollDelta),
      )

      container.scrollLeft = newScrollLeft
    }

    const handleMouseUp = () => {
      setIsDragging(false)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }
  }, [isDragging, totalColumns])

  // --- Клик по сегменту: скроллим к конкретной колонке ---
  const handleSegmentClick = (index) => {
    const container = scrollContainerRef.current
    if (!container) return

    const columnElements = getColumnElements()
    const targetEl = columnElements[index]
    if (!targetEl) return

    const { scrollWidth, clientWidth } = container
    const maxScroll = scrollWidth - clientWidth
    if (maxScroll <= 0) return

    // Позиция колонки относительно контейнера
    const targetLeft = targetEl.offsetLeft
    const columnWidth = targetEl.offsetWidth

    // Центрируем колонку
    let targetScroll = targetLeft - (clientWidth - columnWidth) / 2

    // Первая колонка — точно в начало
    if (index === 0) {
      targetScroll = 0
    }

    // Последняя колонка — точно в конец (чтобы была видна целиком)
    if (index === totalColumns - 1) {
      targetScroll = maxScroll
    }

    targetScroll = Math.max(0, Math.min(maxScroll, targetScroll))

    container.scrollTo({
      left: targetScroll,
      behavior: 'smooth',
    })
  }
  // ============================================================

  return (
    <div className={st.container}>
      <div className={st.dealsHeader}>
        <div className={st.header}>
          <div className={st.titleBlock}>
            <h1 className={st.title}>
              {funnels.filter((f) => f.id === +funnelId)[0]?.name}
            </h1>
            <ActionMenu
              iconType={'arrow'}
              menu={menuItems}
              action={(actionName) => {
                const actionFunction = actionFunctions[actionName]
                if (actionFunction) {
                  actionFunction()
                }
              }}
              right
            />
          </div>

          {windowWidth < 768 ? (
            <MultiActionMenu
              menu={menuMobile}
              action={action}
              sortOrder={sortOrder}
            />
          ) : (
            <div className={st.dealHeadBtn}>
              <div className={st.dealCountWrapper}>
                <span className={st.dealCountLabel}>Сделок:</span>
                <span className={st.dealCountValue}>{totalDealsCount}</span>
              </div>
              <div className={st.dealHeadBtn__divider}></div>
              <MultiActionMenu
                menu={menu}
                action={action}
                sortOrder={sortOrder}
              />

              <div className={st.dealHeadBtn__divider}></div>

              <MergeButton />
              <MassEditButton />
              {/*<MassAddTasksButton />*/}
              <ClearSelectionButton />

              {checkPermList(permissions.edit_funnels_crm) && (
                <Button
                  to={`/crm/funnels/?funnel_id=${funnelId}`}
                  text={translate.set_up_funnel}
                  withIcon
                />
              )}

              <Button
                text={translate.new_deal}
                onClick={addNewDealModal}
                withIcon
              />
            </div>
          )}
        </div>
        <div className={st.searchFilterValues}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: translate.search,
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={`${translate.search}...`}
            value={filter?.search || ''}
          />
          {!!filterTextValues.length && (
            <FilterTextValues onDelete={(key) => resetFilter(key)} />
          )}

          {isOpenFilter && (
            <AsideFilter
              translate={translate}
              getFilterParams={updateFilter}
              config={filterCfg}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
            />
          )}
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className={st.containerCards}>
          <div ref={scrollContainerRef} className={st.scrollContainer}>
            <div className={st.cardsColumns}>
              <DragDropContext onDragEnd={handleDragEnd}>
                {visibleColumns.map((column, idx) => {
                  const isLastColumn = idx === visibleColumns.length - 1

                  return (
                    <Droppable
                      key={column.id}
                      droppableId={column.id.toString()}
                    >
                      {(provided, snapshot) => (
                        <div
                          data-column-index={idx}
                          className={st.columnWrapper}
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          <ColumnDeals
                            provided={provided}
                            snapshot={snapshot}
                            filter={filterForColumns}
                            column={column}
                            dealsMap={dealsMap?.[column.id]}
                            setDealsMap={setDealsMap}
                            sortOrder={sortOrder}
                            totalMap={totalMap}
                            setTotalMap={setTotalMap}
                            page={page}
                            setPage={setPage}
                            funnelId={funnelId}
                            addNewDealModal={addNewDealModal}
                            translate={translate}
                            columns={visibleColumns}
                            isLastColumn={isLastColumn}
                            isSpecialColumn={isSpecialColumn(column.id)}
                            selectedDeals={selectedDeals}
                            toggleDealSelection={toggleDealSelection}
                            onSelectAllInColumn={handleSelectAllInColumn}
                          />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  )
                })}
              </DragDropContext>
            </div>
          </div>

          {/* ЗАКРЕПЛЕННЫЙ ДИСКРЕТНЫЙ СКРОЛЛБАР */}
          {hasScroll && totalColumns > 0 && (
            <div ref={scrollbarRef} className={st.discreteScrollbar}>
              {Array.from({ length: totalColumns }).map((_, index) => {
                const isVisible =
                  index >= visibleRange[0] && index <= visibleRange[1]

                return (
                  <div
                    key={index}
                    className={`${st.scrollSegment} ${
                      isVisible ? st.visibleSegment : ''
                    } ${isDragging ? st.dragging : ''}`}
                    onMouseDown={handleScrollbarMouseDown}
                    onClick={() => !isDragging && handleSegmentClick(index)}
                    title={`Колонка ${index + 1}`}
                  />
                )
              })}
            </div>
          )}

          {isMergeModalOpen && (
            <MergeDealsForm
              dealsForMerge={dealsForAction}
              onClose={closeMergeModal}
              onMerge={handleMerge}
              translate={translate}
              funnelId={funnelId}
            />
          )}

          {isMassEditModalOpen && (
            <MassEditDealsForm
              dealsForEdit={dealsForAction}
              onClose={closeMassEditModal}
              onSave={handleMassEdit}
              translate={translate}
              funnelId={funnelId}
            />
          )}

          {isMassAddTasksModalOpen && (
            <MassAddTasksForm
              dealsForTasks={dealsForAction}
              onClose={closeMassAddTasksModal}
              onSave={handleMassAddTasks}
              translate={translate}
              funnelId={funnelId}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default observer(Deals)
